import angular from 'angular';

class doCtrl {
  /* @ngInject */
  constructor(
    $scope,
    $state,
    $translate,
    i18nService,
    DematPlatformService,
    PrincipalSvc,
    CompanyFilter,
    ContainersFilter,
    COUNTRIES,
    uiGridConstants
  ) {
    this.$scope = $scope;
    this.$state = $state;
    this.$translate = $translate;
    this.i18nService = i18nService;
    this.DematPlatformService = DematPlatformService;
    this.PrincipalSvc = PrincipalSvc;
    this.CompanyFilter = CompanyFilter;
    this.ContainersFilter = ContainersFilter;
    this.COUNTRIES = COUNTRIES;
    this.uiGridConstants = uiGridConstants;
  }

  $onInit() {
    this.i18nService.setCurrentLang(this.$translate.use());

    this.activeTabIndex = 0;

    // Nom de l'onglet actif
    this.activeTabName = this.activeTab.tabName;

    this.tabs = {
      principal: false,
      company: false,
      container: false
    };

    this.$scope.getTableHeight = function(gridApi) {
      var rowHeight = 30;
      var headerHeight = 30;
      var scrollHeight = 20;
      var footerHeight = 32;
      return {
        height:
          gridApi.core.getVisibleRows(gridApi.grid).length * rowHeight +
          headerHeight +
          scrollHeight +
          footerHeight +
          'px'
      };
    };
    // Initialise l'état initial des onglets
    this.updateTabStatus();
  }

  // Change l'onglet actif
  selectTab(tabName) {
    if (this.activeTabName === tabName) return;
    this.$state.go('do', { tabName: tabName }, { notify: false });
    this.activeTabName = tabName;
    this.updateTabStatus();
  }

  updateTabStatus() {
    this.tabs.principal = false;
    this.tabs.company = false;
    this.tabs.container = false;
    switch (this.activeTabName) {
      case 'principal':
        this.tabs.principal = true;
        this.activeTabIndex = 0;
        break;
      case 'company':
        this.tabs.company = true;
        this.activeTabIndex = 1;
        break;
      case 'container':
        this.tabs.container = true;
        this.activeTabIndex = 2;
        break;
      default:
        break;
    }
  }

  selectTabPrincipal() {
    this.selectTab('principal');
  }
  selectTabCompany() {
    this.selectTab('company');
  }
  selectTabContainer() {
    this.selectTab('container');
  }

  goToCompany(row) {
    var companyFilter = new this.CompanyFilter();
    companyFilter.setPrincipalEid(row.entity.principalEid);
    this.PrincipalSvc.setCompanyListFilter(companyFilter);
    this.selectTab('company');
  }

  goToContainer(row) {
    var containersFilter = new this.ContainersFilter();
    containersFilter.setPrincipalEid(row.entity.principalEid);
    containersFilter.setCompanyId(row.entity.companyId);
    this.PrincipalSvc.setContainerListFilter(containersFilter);
    this.selectTab('container');
  }
}

angular.module('do').component('do', {
  templateUrl: require('./do.html'),
  controller: doCtrl,
  bindings: {
    activeTab: '<'
  }
});
